module.exports = __webpack_public_path__ + "img/hero_notion.1abf98a7.webp";